@let tabindex = expanded ? 0 : -1;
@let isAriaHidden = !expanded;

<aside
  class="template-style-list-wrapper border-round-bottom-left-md flex flex-column fixed w-auto bg-white shadow-4 transition-linear transition-duration-200 z-3 p-4"
  [class.template-style-list-wrapper--open]="expanded"
>
  <div
    class="open-style-list-button border-round-top-left-md border-round-bottom-left-md flex justify-content-center align-items-center bg-white absolute top-0 cursor-pointer shadow-4"
    role="button"
    [attr.tabindex]="tabindex"
    (click)="toggleIsOpen($event)"
    (keydown.enter)="toggleIsOpen($event)"
    (keydown.space)="toggleIsOpen($event)"
  >
    <i class="las text-3xl" [class.la-caret-left]="!expanded" [class.la-caret-right]="expanded"></i>
  </div>

  <h3 class="section-content-heading text-center m-b-4">{{ selectedTemplateTitle }}</h3>

  <ul
    class="template-style-list border-color-default flex flex-column gap-2 border-1 border-round-sm shadow-1 overflow-x-hidden sm:overflow-auto"
  >
    @for (styleItem of styleList | keys; track styleItem.key) {
      @let styleKey = styleItem.key;
      @let inputType = styleItem.value.inputType;

      @if (inputType) {
        <li
          class="template-style-list-item text-sm flex flex-column justify-content-between align-items-center border-round-sm p-2 md:flex-row md:align-items-center"
          (mouseenter)="mouseOver(styleKey)"
          (mouseleave)="mouseLeave()"
        >
          <label
            class="pointer-events-none align-self-start w-full overflow-hidden text-overflow-ellipsis md:align-self-center"
            [for]="styleKey"
          >
            {{ styleKey }}
          </label>

          @if (allSkinVariables) {
            @switch (inputType) {
              @case ('color') {
                <input
                  class="template-style-list-item-input w-full shadow-1 md:w-auto"
                  readonly="readonly"
                  [id]="styleKey"
                  [value]="allSkinVariables[styleKey]"
                  [style.background]="allSkinVariables[styleKey]"
                  [attr.tabindex]="tabindex"
                  [cpPosition]="'auto'"
                  [cpOutputFormat]="'rgba'"
                  [cpAlphaChannel]="'always'"
                  [cpSaveClickOutside]="true"
                  [cpCloseClickOutside]="true"
                  [colorPicker]="allSkinVariables[styleKey]"
                  (change)="checkIfEmpty($event, styleKey)"
                  (colorPickerChange)="inputChanged(styleKey, $event)"
                  (cpToggleChange)="togglePicker($event)"
                />
              }
              @case ('text') {
                <input
                  class="style-list-item-input w-full shadow-1 md:w-auto"
                  [value]="allSkinVariables[styleKey]"
                  (change)="inputChanged(styleKey, $event.target.value)"
                />
              }
            }
          }
        </li>
      }
    }
  </ul>

  <div class="flex flex-wrap p-3">
    <ls-button
      class="inline-block w-6"
      data-nested-translation="translations.button.update"
      appAddAttributes
      [addAttributes]="{ button: { 'aria-hidden': isAriaHidden, tabindex } }"
      [styleClass]="'button-primary'"
      [color]="'primary'"
      [size]="'sm'"
      [label]="'translations.button.update' | translate | hideTranslation"
      (onClick)="openModalWindow('update')"
    />

    <ls-button
      class="inline-block w-6"
      data-nested-translation="translations.button.load"
      appAddAttributes
      [addAttributes]="{ button: { 'aria-hidden': isAriaHidden, tabindex } }"
      [styleClass]="'button-primary'"
      [color]="'primary'"
      [size]="'sm'"
      [label]="'translations.button.load' | translate | hideTranslation"
      (onClick)="openModalWindow('load')"
    />

    @if (eventType) {
      <div class="w-full m-t-3">
        <ls-button
          class="inline-block w-6"
          data-nested-translation="translations.button.create"
          appAddAttributes
          [addAttributes]="{ button: { 'aria-hidden': isAriaHidden, tabindex } }"
          [styleClass]="'button-primary'"
          [color]="'primary'"
          [size]="'sm'"
          [label]="'translations.button.create' | translate | hideTranslation"
          (onClick)="openModalWindow('create')"
        />

        <ls-button
          class="inline-block w-6"
          appAddAttributes
          [addAttributes]="{ button: { 'aria-hidden': isAriaHidden, tabindex } }"
          [attr.data-translation]="'translations.button.save.' + eventType"
          [styleClass]="'button-primary'"
          [color]="'primary'"
          [size]="'sm'"
          [label]="'translations.button.save.' + eventType | translate | hideTranslation"
          (onClick)="openModalWindow('save')"
        />
      </div>
    }
  </div>
</aside>

<ls-modal
  class="modal-scrollable"
  [attr.data-nested-translation]="'modalWindow.colorizer.' + modalWindowType + '-title' + eventType"
  [title]="modalTitle"
  [visible]="modalWindowOpen"
  [closable]="false"
  [footerContent]="true"
>
  @switch (modalWindowType) {
    @case (ColorizerModalTypes.Load) {
      @for (template of allStyleTemplates$ | async; track $index) {
        <div
          class="event-tile flex justify-content-between align-items-center cursor-pointer border-round-sm p-6 m-b-6"
          tabindex="0"
          [class.selected-event]="preselectedTemplate?.id === template.id"
          (click)="preselectTile($event, template)"
          (keydown.enter)="preselectTile($event, template)"
          (keydown.space)="preselectTile($event, template)"
        >
          <h3 class="text-white m-l-3">{{ template.title }}</h3>
        </div>
      }
    }
    @case (ColorizerModalTypes.Create) {
      <div class="block text-center">
        <input
          class="save-template-input w-full sm:w-auto"
          type="text"
          placeholder="Name of the template"
          required
          [(ngModel)]="templateTitle"
        />
      </div>
    }
    @case (ColorizerModalTypes.Save) {
      <p class="text-color-error" data-translation="'modalWindow.colorizer.warning'">
        {{
          'modalWindow.colorizer.warning'
            | translate: { transaltionEventTitle: translationEventTitle, templateTitle: selectedTemplateTitle }
            | hideTranslation
        }}
      </p>
    }
  }

  <ng-template lsTemplate="footer">
    <div class="flex flex-wrap justify-content-center gap-1">
      @if (modalWindowType === ColorizerModalTypes.Load) {
        <ls-button
          [styleClass]="'button-primary'"
          [color]="'primary'"
          [size]="'md'"
          [label]="'modalWindow.' + modalWindowType | translate | hideTranslation"
          [attr.data-nested-translation]="'modalWindow.' + modalWindowType"
          [disabled]="!preselectedTemplate"
          (onClick)="submitModalWindow($event)"
        />
      }

      @if (modalWindowType === ColorizerModalTypes.Create) {
        <ls-button
          [styleClass]="'button-primary'"
          [color]="'primary'"
          [size]="'md'"
          [label]="'modalWindow.' + modalWindowType | translate | hideTranslation"
          [attr.data-nested-translation]="'modalWindow.' + modalWindowType"
          [disabled]="!templateTitle"
          (onClick)="submitModalWindow($event)"
        />
      }

      @if (modalWindowType !== ColorizerModalTypes.Create && modalWindowType !== ColorizerModalTypes.Load) {
        <ls-button
          [styleClass]="'button-primary'"
          [color]="'primary'"
          [size]="'md'"
          [label]="'modalWindow.' + modalWindowType | translate | hideTranslation"
          [attr.data-nested-translation]="'modalWindow.' + modalWindowType"
          (onClick)="submitModalWindow($event)"
        />
      }

      <ls-button
        data-nested-translation="modalWindow.close"
        [styleClass]="'button-secondary'"
        [color]="'secondary'"
        [size]="'md'"
        [label]="'modalWindow.close' | translate | hideTranslation"
        (onClick)="closeModalWindow($event)"
      />
    </div>
  </ng-template>
</ls-modal>
